import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCoin2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconCoin2"><Path fillRule="evenodd" clipRule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM10.9393 9.06066L9.06066 10.9393C8.47487 11.5251 8.47487 12.4749 9.06066 13.0607L10.9393 14.9393C11.5251 15.5251 12.4749 15.5251 13.0607 14.9393L14.9393 13.0607C15.5251 12.4749 15.5251 11.5251 14.9393 10.9393L13.0607 9.06066C12.4749 8.47487 11.5251 8.47487 10.9393 9.06066Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCoin2;
